export const MAXIMUM_POST_CHARACTERS = 50000;
export const MAXIMUM_POST_MENTIONEES = 30;
//# sourceMappingURL=constants.js.map